function getValidDate(dateValue) {
  if (dateValue === undefined || dateValue === null || dateValue === '') {
    return null;
  }
  const parsedDate = new Date(dateValue);
  if (Number.isNaN(parsedDate.getTime()) === true) {
    return null;
  }
  return parsedDate;
}

function padDatePart(value) {
  return String(value).padStart(2, '0');
}

export function formatDateTimeForViewer(dateValue) {
  const parsedDate = getValidDate(dateValue);
  if (parsedDate === null) {
    if (dateValue === undefined || dateValue === null) {
      return '';
    }
    return String(dateValue);
  }
  return `${parsedDate.getFullYear()}-${padDatePart(parsedDate.getMonth() + 1)}-${padDatePart(parsedDate.getDate())} ${padDatePart(parsedDate.getHours())}:${padDatePart(parsedDate.getMinutes())}:${padDatePart(parsedDate.getSeconds())}`;
}

export function formatDateForViewer(dateValue) {
  const parsedDate = getValidDate(dateValue);
  if (parsedDate === null) {
    if (dateValue === undefined || dateValue === null) {
      return '';
    }
    return String(dateValue);
  }
  return `${parsedDate.getFullYear()}-${padDatePart(parsedDate.getMonth() + 1)}-${padDatePart(parsedDate.getDate())}`;
}


